import React from 'react';
import PropTypes from 'prop-types';
import MonthPicker from 'shared/components/monthPicker/MonthPicker';
import BootstrapCard from 'shared/components/bootstrapCard/BootstrapCard';

const SelectImportPeriod = ({ onChange, month, year}) => (
  <BootstrapCard title="2. Set Period" width={ 600 } margin={ '15px 0' }>
    <MonthPicker 
      defaultLabel="Select Year & Month" 
      onChange={ onChange } 
      month={ month } 
      year={ year } 
      yearsBefore={ 4 } 
      yearsBeyond={ 1 } 
    />
  </BootstrapCard>
);

SelectImportPeriod.propTypes = {
  onChange: PropTypes.func.isRequired,
  month: PropTypes.string.isRequired,
  year: PropTypes.number.isRequired
};

export default SelectImportPeriod;



// WEBPACK FOOTER //
// ./src/components/importData/comp/selectImportPeriod/SelectImportPeriod.js